import React from 'react';
import {
  getCrmContactDisplayPhotoUrl,
  getCrmCompanyLogoDisplayUrl,
} from '../../services/firestoreService';

const initialsFor = (account, fallback) => {
  const c = account?.contact || {};
  const fromContact = `${c.firstName?.[0] || ''}${c.lastName?.[0] || ''}`.trim();
  if (fromContact) return fromContact.toUpperCase();
  const name = (fallback || account?.company || '?').trim();
  return name[0].toUpperCase();
};

/**
 * Main-contact headshot with the company logo tucked over its bottom-right
 * corner. Falls back to initials when there's no photo and to the company's
 * first letter when there's no logo. Shared by the team fulfillment cards on
 * the CRM Dashboard (HR, Marketing).
 */
const ContactWithLogo = ({ account, company }) => {
  const photo = account ? getCrmContactDisplayPhotoUrl(account) : '';
  const logo = account ? getCrmCompanyLogoDisplayUrl(account) : '';
  const initials = initialsFor(account, company);
  const companyInitial = (company || account?.company || '?').trim()[0]?.toUpperCase() || '?';

  return (
    <div className="relative w-14 h-14 shrink-0">
      <div className="w-14 h-14 rounded-full overflow-hidden ring-2 ring-white dark:ring-gray-900 shadow-sm bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
        {photo ? (
          <img src={photo} alt="" className="w-full h-full object-cover" />
        ) : (
          <span className="text-base font-semibold text-gray-600 dark:text-gray-200">{initials}</span>
        )}
      </div>
      <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full overflow-hidden bg-white dark:bg-gray-800 ring-2 ring-white dark:ring-gray-900 shadow flex items-center justify-center">
        {logo ? (
          <img src={logo} alt="" className="max-w-[80%] max-h-[80%] object-contain" />
        ) : (
          <span className="text-[10px] font-bold text-gray-500 dark:text-gray-300">{companyInitial}</span>
        )}
      </div>
    </div>
  );
};

export default ContactWithLogo;
